import createUserManager from './createUserManager'
import createRedirectUri from './createRedirectUri'

const config = {
  authority: `${
    process.env.REACT_APP_AUTH_ENDPOINT
  }/.well-known/openid-configuration`,
  client_id: process.env.REACT_APP_CLIENT_ID,
  scope: `profile email openid aws.cognito.signin.user.admin webpremios.campaigns/${
    process.env.REACT_APP_TENANT_ID
  }`,
  response_type: 'token id_token',
  redirect_uri: createRedirectUri()
}

export default createUserManager(config)



// WEBPACK FOOTER //
// ./src/Auth/userManager.js